import React, { useEffect } from "react";
// import Image from "../../assets/bgimg.png";
import Image from "../../Pyragon/Isometric-Tokenomics.png";
import "./tokennomics.css";
import AOS from 'aos';
import "aos/dist/aos.css";

import Fade from 'react-reveal/Fade';
import Tokenomics from '../../site/content/tokenomics.json'

const Tokennomics = () => {
  useEffect(()=>{
    AOS.init();
  
  } , []);
  
  return (
    <div className="token">

      <div id="token-group-1">
      <Fade bottom cascade>
        <h1 className="heading">{Tokenomics["title"]}</h1>
        <div className="para-token">
          <p>{Tokenomics["para-one"]}</p>
          {/* <p>{Tokenomics["para-two"]}</p>
          <p>{Tokenomics["para-three"]}</p>
          <p>{Tokenomics["para-four"]}</p> */}
        </div>
      </Fade>
      
      </div>
      <div className="token-img">
          <img src={Image} alt="Image"/>
        </div>
    </div>
  );
};

export default Tokennomics;
